import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 1160px;
  margin: 0 auto;
  padding: 0 1.25rem;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 0 2rem;
  }
`;

export const Section = styled.section`
  padding: 3.5rem 0;

  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 5.5rem 0;
  }
`;

/* Acento en script sobre el título principal, ej. "nuestra" / "el" */
export const ScriptAccent = styled.span`
  display: block;
  font-family: ${({ theme }) => theme.fonts.display};
  font-size: clamp(1.4rem, 3vw, 2rem);
  text-transform: none;
  letter-spacing: 0;
  color: ${({ theme }) => theme.colors.gold};
  margin-bottom: -0.2em;
`;

export const SectionTitle = styled.h2`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: clamp(1.9rem, 5vw, 2.8rem);
  text-align: ${({ $align }) => $align || 'center'};
  color: ${({ theme }) => theme.colors.text};
  margin-bottom: 0.4rem;

  &::after {
    content: '';
    display: block;
    width: 64px;
    height: 2px;
    background: ${({ theme }) => theme.colors.gold};
    margin: 0.6rem ${({ $align }) => ($align === 'left' ? '0' : 'auto')} 0;
  }
`;

export const SectionSubtitle = styled.p`
  text-align: ${({ $align }) => $align || 'center'};
  color: ${({ theme }) => theme.colors.textMuted};
  max-width: 640px;
  margin: 0 auto 2.5rem;

  ${({ $align }) => $align === 'left' && 'margin-left: 0;'}
`;

export const Grid = styled.div`
  display: grid;
  gap: 1.5rem;
  grid-template-columns: repeat(auto-fit, minmax(${({ $min }) => $min || '260px'}, 1fr));
`;
